module.exports = __webpack_public_path__ + "img/region-33.c603d743.png";